import { useState } from "react";
import { motion } from "framer-motion";

const GOLD = "#C4A671";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

const FAQS = [
  {
    q: "Che cos'è La Valle degli Iblei?",
    a: "Una maison enologica luxury fondata e diretta da Claudio Pucci, dedicata alle micro-vinificazioni d'eccellenza della Sicilia sud-orientale. Selezioniamo lotti limitati dagli altopiani calcarei iblei e li riserviamo all'alta ristorazione, ai sommelier e ai buyer internazionali attraverso un modello di vendita su allocazione.",
  },
  {
    q: "Qual è il bagaglio di esperienza di Claudio Pucci, fondatore della Maison?",
    a: "La competenza di Claudio Pucci nasce da 25 anni di lavoro e dedizione sul campo presso l'Azienda Agricola COS, realtà fondamentale per la sua formazione enologica e contadina. Forte di questo percorso di rigore, Claudio ha successivamente intrapreso la propria strada d'autore, dando vita a La Valle degli Iblei per esprimere una personale ed elegante visione del territorio.",
  },
  {
    q: "Quali vini produce la Maison?",
    a: "Quattro referenze d'autore: Blanche, Blanc de Noirs in edizione limitata di sole 1.333 bottiglie numerate a mano; Claire, rosato di Frappato e Nero d'Avola in micro-lotto dal vivo colore rosa salmone con riflessi rame e corallo e dal finale sapido e gastronomico; Scilla, Inzolia Terre Siciliane I.G.T. dal profilo fresco e marino; Terra Arsa, Nero d'Avola DOC Sicilia profondo e mediterraneo, affinato esclusivamente in acciaio inox.",
  },
  {
    q: "Che cos'è Blanche e perché si definisce Blanc de Noirs?",
    a: "Blanche è il vertice della maison: un bianco ottenuto da uve rosse di Frappato degli Iblei vinificate in bianco, completate da un blend d'autore di Grillo, Catarratto e Zibibbo. Ne esistono sole 1.333 bottiglie trasparenti, numerate progressivamente a mano e riservate all'alta ristorazione e al Sommelier Club.",
  },
  {
    q: "Che cos'è Claire, il rosato siciliano in micro-lotto?",
    a: "Claire è il nostro rosato d'autore: Frappato 50% e Nero d'Avola 50% vinificati in rosa con brevissimo contatto, IGT Terre Siciliane. Un vivo rosa salmone con caldi riflessi rame e corallo, tensione minerale del suolo calcareo ibleo, note di pompelmo rosa, scorza d'arancia e piccoli frutti di bosco. Micro-lotto Vintage 2025, su allocazione.",
  },
  {
    q: "Siete fornitori di vini per ristoranti, hotel e wine bar?",
    a: "Sì. Siamo un fornitore di vini siciliani d'autore dedicato esclusivamente al canale Ho.Re.Ca.: ristoranti fine dining, hotel 5 stelle, wine bar d'élite e distributori selezionati, in Italia e all'estero. Listino B2B lineare riservato ai titolari di Partita IVA, cartoni brandizzati da 6 bottiglie, consegna inclusa in Sicilia da 3 cartoni.",
  },
  {
    q: "Quali vini iblei scegliere per la carta dei vini di un ristorante?",
    a: "Suggeriamo una logica a due fasce: Scilla (Inzolia) e Terra Arsa (Nero d'Avola) come sweet spot ad alta rotazione, fascia carta consigliata 22–25 €; Blanche (Blanc de Noirs) e Claire (rosato micro-lotto) come cuvée speciali d'autore, fascia carta 45–50 €. Le linee guida complete per la marginalità sono nel listino riservato.",
  },
  {
    q: "Come funziona la vinificazione in anfora di terracotta e che impatto ha sul vino?",
    a: "La vinificazione e l'affinamento in anfore di terracotta rappresentano una scelta di purezza assoluta. La terracotta è un materiale poroso che permette una lentissima e naturale micro-ossigenazione del vino, senza cedere aromaticità di legno o tannini esogeni. In 25 anni di esperienza con l'anfora negli Iblei, Claudio Pucci ha affinato la tecnica della macerazione sulle bucce e della sigillatura a mano: il vino \"respira\" attraverso la terra, preservando intatta la freschezza, la mineralità del suolo calcareo e l'espressione varietale pura dei vitigni autoctoni come il Frappato.",
  },
  {
    q: "Qual è la differenza tra l'uso dell'anfora e quello delle botti di legno francese?",
    a: "Ogni contenitore ha una sua funzione sartoriale nell'architettura di una cuvée. L'anfora rispetta il frutto nudo e la componente minerale; le botti grandi di rovere francese donano al vino equilibrio, stabilità e un'evoluzione lenta senza coprirne la spinta floreale; le botti piccole (barrique e tonneau), usate con estrema misura, servono a rifinire la trama tannica dei rosati e dei rossi più complessi. Ne La Valle degli Iblei, l'uso del legno non è mai prevaricante: è una cornice elegante che serve a far risaltare il quadro, mai a nasconderlo.",
  },
  {
    q: "Perché la potatura secca e la potatura verde sono decisive per la qualità dei micro-lotti?",
    a: "La qualità di un grande vino si decide in inverno e in primavera con le forbici in mano. La potatura secca (come l'impostazione a T o a cordone speronato) definisce la struttura della pianta, la sua longevità e il flusso della linfa sul legno vecchio. La potatura verde (defogliazione mirata e selezione dei germogli a inizio estate) serve invece a calibrare la resa per ceppo, garantire la perfetta aerazione dei grappoli e proteggere le uve dalle scottature del sole siciliano. Questo rigore contadino permette di ottenere acini concentrati, sani e ricchi di corredo aromatico naturale.",
  },
  {
    q: "Cos'è la pressatura soffice a polmone e perché protegge l'eleganza del mosto?",
    a: "La pressatura soffice a polmone è una tecnica delicatissima che rispetta l'integrità del grappolo. A differenza delle presse meccaniche aggressive che rischiano di frantumare i vinaccioli ed estrarre tannini amari o vegetali, la pressatura a polmone esercita una pressione graduale e soffice. Questo permette di estrarre solo il \"fiore\" del mosto, mantenendo la limpidezza dei profumi, la brillantezza del colore nei nostri rosati (come Claire) e una tessitura tannica seta e velluto nei vini rossi d'allocazione.",
  },
  {
    q: "Cosa significa acquistare su allocazione?",
    a: "Le tirature limitatissime impongono un modello di allocazione: ogni annata viene assegnata a un numero ristretto di ristoranti, hotel e distributori selezionati, con poche casse per singolo locale. Listini e disponibilità sono riservati e comunicati esclusivamente via email dall'ufficio di Claudio Pucci, dopo la qualifica del profilo del richiedente.",
  },
  {
    q: "Che cos'è il Registro delle Allocazioni d'Autore?",
    a: "È il Registro Globale in cui i grandi chef partner iscrivono le creazioni nate attorno ai vini della maison. Ogni piatto è accompagnato dalla Matrice delle Affinità Sensoriali, una perizia che ne valuta estetica, armonia, affinità col vino ed equilibrio. L'iscrizione avviene tramite un Codice di Allocazione personale, fornito con l'acquisto di un lotto.",
  },
  {
    q: "Cosa rende unico il terroir degli Iblei?",
    a: "Gli altopiani calcarei iblei, nella Sicilia sud-orientale, uniscono la siccità dell'entroterra, la forte escursione termica e la brezza del mare Ionio. Ne nascono vini di rara tensione e sapidità: li raccontiamo con il claim «Trasformiamo la siccità in eleganza, il mito in calice».",
  },
  {
    q: "La Maison lavora con ristoranti e buyer internazionali?",
    a: "Sì. La Valle degli Iblei si rivolge all'alta ristorazione (Ho.Re.Ca.), ai luxury hotel e ai buyer internazionali. Per l'export le condizioni sono franco magazzino (Ex-Works); in Sicilia la consegna diretta è inclusa a partire da tre cartoni. Le bottiglie viaggiano esclusivamente in cartoni personalizzati da sei.",
  },
  {
    q: "Come si richiede un'allocazione o il listino riservato?",
    a: "Attraverso il modulo di contatto qui sotto o scrivendo a info@lavalledegliiblei.it, indicando il proprio locale e la referenza d'interesse. L'ufficio di Claudio Pucci verifica il profilo e risponde con il listino riservato e la disponibilità dell'annata. I prezzi non sono mai pubblicati online.",
  },
];

function FaqItem({ item, index, open, onToggle }) {
  return (
    <div className="border-b" style={{ borderColor: "rgba(196,166,113,0.18)" }}>
      <button
        data-testid={`faq-question-${index}`}
        onClick={onToggle}
        className="w-full flex items-baseline justify-between gap-6 py-6 text-left group"
        aria-expanded={open}
      >
        <span
          className="font-serif-display text-[17px] sm:text-[19px] leading-snug transition-colors duration-300"
          style={{ color: open ? GOLD : "#F2EFE8" }}
        >
          {item.q}
        </span>
        <span
          aria-hidden
          className="shrink-0 text-[18px] font-light transition-transform duration-500"
          style={{ color: GOLD, transform: open ? "rotate(45deg)" : "none" }}
        >
          +
        </span>
      </button>
      <div
        className="overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{ maxHeight: open ? 560 : 0, opacity: open ? 1 : 0 }}
      >
        <p
          data-testid={`faq-answer-${index}`}
          className="pb-7 pr-10 text-[13.5px] sm:text-[14.5px] leading-[1.9] font-light max-w-3xl"
          style={{ color: "#C9C3B5" }}
        >
          {item.a}
        </p>
      </div>
    </div>
  );
}

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#0A0A0A] text-[#F2EFE8] overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-25 pointer-events-none" aria-hidden />
      <div className="hairline" style={{ background: "rgba(196,166,113,0.18)" }} />

      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="grid lg:grid-cols-[380px_1fr] gap-12 lg:gap-20">
          <div>
            <motion.div {...reveal(0)} className="flex items-center gap-5 mb-7">
              <span className="section-num text-3xl" style={{ color: GOLD }}>12</span>
              <div className="h-px w-14" style={{ background: GOLD }} />
              <span className="overline text-[10px]" style={{ color: GOLD }}>
                Domande &amp; Risposte
              </span>
            </motion.div>
            <motion.h2
              {...reveal(0.08)}
              className="font-serif-display leading-[1.02]"
              style={{ fontSize: "clamp(2rem, 3.6vw, 3.2rem)" }}
            >
              La Maison{" "}
              <span className="italic font-light" style={{ color: GOLD }}>risponde.</span>
            </motion.h2>
            <motion.p
              {...reveal(0.16)}
              className="mt-6 text-[13.5px] leading-[1.85] font-light max-w-sm"
              style={{ color: "#8B7A55" }}
            >
              Le domande che riceviamo più spesso da chef, sommelier e buyer —
              sull&apos;allocazione, sui vini e sul Registro.
            </motion.p>
          </div>

          <motion.div {...reveal(0.14)} data-testid="faq-list">
            {FAQS.map((item, i) => (
              <FaqItem
                key={i}
                item={item}
                index={i}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
              />
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
